import API, { BASE_ASSET_URL, getloginUserId } from "../api/axios";
import { useState, useEffect, useRef ,useMemo} from "react";
import Select from "react-select";
import CoverImageUpload from "../components/CoverImageUpload";
import { toast } from "react-toastify";
import { Link, useNavigate } from "react-router-dom";
import { ProjectFormProvider } from "../api/ProjectFormContext";
import ProjectCompletionCard from "../components/ProjectCompletionCard";
import Layoutsecond from "../components/Layoutsecond";
import $ from "jquery";
import "summernote/dist/summernote-lite.css" ;
import "summernote/dist/summernote-lite.js";
import TermsAndConditionModal from "../components/TermsAndConditionmodal";

export default function ProjectForm({ project }) {
  const isEditMode = Boolean(project?.id);
  const summernoteDescriptionRef = useRef(null);
  const summernoteFeaturesRef = useRef(null);
  const summernoteBenefitsRef = useRef(null);
  const [errors, setErrors] = useState({});
  const [hasSubmitted, setHasSubmitted] = useState(false);
  const [categories, setCategories] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();
  const [acceptedTerms, setAcceptedTerms] = useState(false);
  const [showTermsModal, setShowTermsModal] = useState(false)

  const today = useMemo(() => {
  const date = new Date();
    return date.toISOString().split('T')[0];
  }, []);

  const getFormDataForSidebar = () => ({
    name: form.name,
    url: form.url,
    tagline: form.tagline,
    category_ids: form.category_ids,
    tech_stack: form.tech_stack,
    description: form.description,
    collaborators: form.collaborators,
    features: form.features,
    benefits: form.benefits,
    start_date_range: form.start_date_range,
  });

  // Updated form state to include start_date_range
  const [form, setForm] = useState({
    name: "",
    tagline: "",
    url: "",
    video: "",
    collaborators: "",
    tech_stack: "",
    category_ids: [], 
    description: "",
    features: "",
    benefits: "",
    completion_percentage: 50,
    start_date_range: "", // New field added
    user_id: getloginUserId(),
  });

  const validateForm = () => {
    const newErrors = {};

    if (!form.name || form.name.trim() === '') {
      newErrors.name = ['Project name is required'];
    }

    if (!form.tagline || form.tagline.trim() === '') {
      newErrors.tagline = ['Tagline is required'];
    } else if (form.tagline.length > 60) {
      newErrors.tagline = ['Tagline must not exceed 60 characters'];
    }

    if (!form.category_ids || form.category_ids.length === 0) {
      newErrors.category_ids = ['At least one category must be selected'];
    }

    if (form.url && form.url.trim() !== '') {
        const urlPattern = /^(https?:\/\/)?([\w-]+(\.[\w-]+)+)([\/\w .-]*)*\/?$/;
        if (!urlPattern.test(form.url.trim())) {
          newErrors.url = ['Please enter a valid URL'];
        }
      }
    

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  useEffect(() => {
    const initSummernote = (ref, key) => {
      if (ref.current) {
        $(ref.current).summernote({
          height: 200,
          placeholder: `Write your ${key}...`,
          toolbar: [
            ["font", ["bold", "underline", "italic", "clear"]],
            ["para", ["ul", "ol", "paragraph"]],
            ["insert", ["link"]],
          ],
          callbacks: {
            onChange: function (contents) {
              setForm((prev) => ({ ...prev, [key]: contents }));
              if (hasSubmitted && errors[key]) {
                setErrors((prev) => ({ ...prev, [key]: null }));
              }
            },
          },
        });
      }
    };

    initSummernote(summernoteFeaturesRef, "features");
    initSummernote(summernoteBenefitsRef, "benefits");
    initSummernote(summernoteDescriptionRef, "description");

    return () => {
      $(summernoteFeaturesRef.current).summernote("destroy");
      $(summernoteBenefitsRef.current).summernote("destroy");
      $(summernoteDescriptionRef.current).summernote("destroy");
    };
  }, []);

  const didInitializeEditor = useRef(false);

  useEffect(() => {
    if (!didInitializeEditor.current && isEditMode && project) {
      if (summernoteFeaturesRef.current) {
        $(summernoteFeaturesRef.current).summernote(
          "code",
          project.features || ""
        );
      }
      if (summernoteBenefitsRef.current) {
        $(summernoteBenefitsRef.current).summernote(
          "code",
          project.benefits || ""
        );
      }
      if (summernoteDescriptionRef.current) {
        $(summernoteDescriptionRef.current).summernote(
          "code",
          project.description || ""
        );
      }

      didInitializeEditor.current = true;
    }
  }, [isEditMode, project]);

  const [logo, setLogo] = useState(null);
  const [logoPreview, setLogoPreview] = useState(null);

  const [coverImages, setCoverImages] = useState([]);
  const [imagesToDelete, setImagesToDelete] = useState([]);
  const [newImages, setNewImages] = useState([]);

  useEffect(() => {
    if (isEditMode && project) {
      setForm({
        name: project.name || "",
        tagline: project.tagline || "",
        url: project.url || "",
        video: project.video || "",
        collaborators: project.collaborators || "",
        tech_stack: project.tech_stack || "",
        category_ids: project.categories?.map((c) => c.id) || [],
        description: project.description || "",
        features: project.features || "",
        benefits: project.benefits || "",
        completion_percentage: project.completion_percentage || 50,
        start_date_range: project.start_date_range || "", // Added for edit mode
        user_id: project.user_id || getloginUserId(),
      });

      if (project.logo_url) {
        setLogoPreview(project.logo_url);
      }

      if (project.images && Array.isArray(project.images)) {
        setCoverImages(
          project.images.map((img) => ({
            id: img.id,
            position: img.position,
            preview: img.image_url.startsWith("http")
              ? img.image_url
              : `${BASE_ASSET_URL}/${img.image_path}`,
            file: null,
            isExisting: true,
          }))
        );
      }
    }

    API.get("/categories")
      .then((res) => {
        if (res.data && res.data.success) {
          setCategories(res.data.data);
        }
      })
      .catch((err) => console.error("Category fetch failed:", err));
  }, [isEditMode, project]);

  const removeLogo = () => {
    setLogo(null);
    setLogoPreview(null);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));

    if (hasSubmitted && errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: null }));
    }
  };

  const handleLogoUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      if (file.size > 15 * 1024 * 1024) {
        setErrors((prev) => ({ ...prev, logo: ['Logo file size must not exceed 15MB'] }));
        return;
      }
      
      if (!file.type.startsWith('image/')) {
        setErrors((prev) => ({ ...prev, logo: ['Please select a valid image file'] }));
        return;
      }

      setLogo(file);
      setLogoPreview(URL.createObjectURL(file));
      
      if (errors.logo) {
        setErrors((prev) => ({ ...prev, logo: null }));
      }
    }
  };

  const handleRemoveImage = (imageIndex) => {
    const imageToRemove = coverImages[imageIndex];

    if (imageToRemove.isExisting && imageToRemove.id) {
      setImagesToDelete((prev) => [...prev, imageToRemove.id]);
    }

    setCoverImages((prev) => prev.filter((_, index) => index !== imageIndex));
  };

  const handleAddImages = (newImageFiles) => {
    const newImageObjects = newImageFiles.map((file) => ({
      id: null,
      position: coverImages.length,
      preview: URL.createObjectURL(file),
      file: file,
      isExisting: false,
    }));

    setCoverImages((prev) => [...prev, ...newImageObjects]);
  };

  const groupedCategories = categories
    .filter((cat) => !cat.parent_id)
    .map((parent) => ({
      label: parent.name,
      options: [
        { value: parent.id, label: parent.name },
        ...categories
          .filter((cat) => cat.parent_id === parent.id)
          .map((sub) => ({ value: sub.id, label: sub.name })),
      ],
    }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setHasSubmitted(true);

    if (!validateForm()) {
      toast.error("Please fix the validation errors before submitting");
      return;
    }

    if (!acceptedTerms) {
      toast.error("You must accept the Terms & Conditions before submitting");
      return;
    }
    
    setIsSubmitting(true);

    const formData = new FormData();

    // Include start_date_range in form data
    Object.entries(form).forEach(([key, value]) => {
      if (Array.isArray(value)) {
        value.forEach((val) => formData.append(`${key}[]`, val));
      } else {
        formData.append(key, value ?? "");
      }
    });

    formData.append("accepted_terms", true);

    if (logo) {
      formData.append("logo", logo);
    }

    if (imagesToDelete.length > 0) {
      imagesToDelete.forEach((imageId) => {
        formData.append("images_to_delete[]", imageId);
      });
    }

    try {
      let response;

      if (isEditMode) {
        const newImageFiles = coverImages.filter(
          (img) => img && !img.isExisting && img.file
        );

        newImageFiles.forEach((img) => {
          formData.append("cover_images[]", img.file);
          formData.append("image_positions[]", img.position);
        });

        formData.append("_method", "PUT");
        response = await API.post(`/projects/${project.id}`, formData);
      } else {
        coverImages.forEach((img) => {
          if (img?.file) {
            formData.append("cover_images[]", img.file);
            formData.append("image_positions[]", img.position);
          }
        });

        response = await API.post("/projects", formData);
      }

      const { data } = response;

      if (data?.success) {
        toast.success(data.message || "Project submitted successfully");
          navigate("/my-projects");
        
        // Reset form including start_date_range
        setForm({
          name: "",
          tagline: "",
          url: "",
          video: "",
          collaborators: "",
          tech_stack: "",
          category_ids: [],
          description: "",
          features: "",
          benefits: "",
          completion_percentage: 50,
          start_date_range: "", // Reset new field
          user_id: getloginUserId(),
        });
        setLogo(null);
        setLogoPreview(null);
        setCoverImages([]);
        setImagesToDelete([]);
        setErrors({});
        setHasSubmitted(false);
      } else {
        toast.error(data.message || "Submission failed. Please try again.");
      }
    } catch (error) {
      console.error("Submission error:", error);

      if (error.response?.status === 422) {
        const validationErrors = error.response.data.errors;
        setErrors(validationErrors);
        toast.error("Please fix the validation errors");
      } else {
        toast.error(error.response?.data?.message || "An error occurred");
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleTermsClick = () => {
    setShowTermsModal(true);
  };

  const handleTermsAccept = () => {
    setAcceptedTerms(true);
    setShowTermsModal(false);
    toast.success("Terms & Conditions accepted");
  };

  const handleTermsModalHide = () => {
    setShowTermsModal(false);
  };

  return (
    <ProjectFormProvider
      formData={form}
      logo={logoPreview}
      coverImages={coverImages}
    >
      <Layoutsecond
        rightSidebar={
          <ProjectCompletionCard
            formData={getFormDataForSidebar()}
            logo={logoPreview}
            coverImages={coverImages}
            categories={categories}
          />
        }>
        <div className="mb-5" style={{ display: 'flex' }}>
          <div style={{ flex: 1 }}>
            <h1 className="title mb-3">{isEditMode ? "Edit Project" : "Submit Project"}</h1>
            <form onSubmit={handleSubmit} className="row g-4">
              <div className="col-md-6">
                <label className="form-label">Project Name <span className="text-danger">*</span></label>
                <input
                  type="text"
                  name="name"
                  value={form.name}
                  className={`form-control ${hasSubmitted && errors.name ? 'is-invalid' : ''}`}
                  onChange={handleChange}
                  placeholder="Enter project name"
                />
                {hasSubmitted && errors.name && (
                  <div className="invalid-feedback d-block">
                    {Array.isArray(errors.name) ? errors.name[0] : errors.name}
                  </div>
                )}
              </div>

              <div className="col-md-6">
                <label className="form-label">Project URL</label>
                <input
                  type="text"
                  name="url"
                  value={form.url}
                  className={`form-control ${hasSubmitted && errors.url ? 'is-invalid' : ''}`}
                  onChange={handleChange}
                  placeholder="https://example.com"
                />
                {hasSubmitted && errors.url && (
                  <div className="invalid-feedback d-block">
                    {Array.isArray(errors.url) ? errors.url[0] : errors.url}
                  </div>
                )}
              </div>

              <div className="col-md-6">
                <label className="form-label">Tagline <span className="text-danger">*</span></label>
                <input
                  type="text"
                  name="tagline"
                  value={form.tagline}
                  maxLength={60}
                  className={`form-control ${hasSubmitted && errors.tagline ? 'is-invalid' : ''}`}
                  onChange={handleChange}
                  placeholder="Brief description of your project"
                />
                <div className="text-end mt-1">
                  <small className="text-muted">{form.tagline.length}/60</small>
                </div>
                {hasSubmitted && errors.tagline && (
                  <div className="invalid-feedback d-block">
                    {Array.isArray(errors.tagline) ? errors.tagline[0] : errors.tagline}
                  </div>
                )}
              </div>

              <div className="col-md-6">
                <label className="form-label">Categories <span className="text-danger">*</span></label>
                <Select
                  isMulti
                  options={groupedCategories}
                  value={categories
                    .filter((cat) => form.category_ids?.includes(cat.id))
                    .map((cat) => ({
                      value: cat.id,
                      label: cat.name,
                    }))}
                  className={`basic-multi-select ${hasSubmitted && errors.category_ids ? 'is-invalid' : ''}`}
                  classNamePrefix="select"
                  placeholder="Select categories..."
                  onChange={(selectedOptions) => {
                    const ids = selectedOptions ? selectedOptions.map((opt) => opt.value) : [];
                    setForm((prev) => ({ ...prev, category_ids: ids }));

                    if (hasSubmitted && errors.category_ids) {
                      setErrors((prev) => ({ ...prev, category_ids: null }));
                    }
                  }}
                />
                {hasSubmitted && errors.category_ids && (
                  <div className="invalid-feedback d-block">
                    {Array.isArray(errors.category_ids) ? errors.category_ids[0] : errors.category_ids}
                  </div>
                )}
              </div>

              <div className="col-md-6">
                <label className="form-label">Collaborators</label>
                <input
                  type="text"
                  name="collaborators"
                  value={form.collaborators}
                  className={`form-control ${hasSubmitted && errors.collaborators ? 'is-invalid' : ''}`}
                  onChange={handleChange}
                  placeholder="e.g. Alice, Bob"
                />
                {hasSubmitted && errors.collaborators && (
                  <div className="invalid-feedback d-block">
                    {Array.isArray(errors.collaborators) ? errors.collaborators[0] : errors.collaborators}
                  </div>
                )}
              </div>
              
              <div className="col-md-6">
                <label className="form-label">Tech Stack</label>
                <input
                  type="text"
                  name="tech_stack"
                  value={form.tech_stack}
                  className={`form-control ${hasSubmitted && errors.tech_stack ? 'is-invalid' : ''}`}
                  onChange={handleChange}
                  placeholder="e.g. React, Node.js, MongoDB"
                />
                {hasSubmitted && errors.tech_stack && (
                  <div className="invalid-feedback d-block">
                    {Array.isArray(errors.tech_stack) ? errors.tech_stack[0] : errors.tech_stack}
                  </div>
                )}
              </div>

              {/* NEW FIELD: Start Date Ranges */}
              <div className="col-md-6">
                <label className="form-label">Start Date Ranges</label>
                <input
                  type="date"
                  name="start_date_range"
                  value={form.start_date_range}
                  className={`form-control ${hasSubmitted && errors.start_date_range ? 'is-invalid' : ''}`}
                  onChange={handleChange}
                  min={today}
                  placeholder="Select start date"
                />
               
                {hasSubmitted && errors.start_date_range && (
                  <div className="invalid-feedback d-block">
                    {Array.isArray(errors.start_date_range) 
                      ? errors.start_date_range[0] 
                      : errors.start_date_range}
                  </div>
                )}
              </div>

              <div className="col-md-6">
                <label className="form-label">Video URL</label>
                <input
                  type="text"
                  name="video"
                  value={form.video}
                  className={`form-control ${hasSubmitted && errors.video ? 'is-invalid' : ''}`}
                  onChange={handleChange}
                  placeholder="https://example.com"
                />
                {hasSubmitted && errors.video && (
                  <div className="invalid-feedback d-block">
                    {Array.isArray(errors.video) ? errors.video[0] : errors.video}
                  </div>
                )}
              </div>

              <div className="col-md-6">
                <label className="form-label">Logo</label>

                {!logoPreview && (
                  <div className="input-file">
                    <input
                      type="file"
                      name="logo"
                      className={`form-control ${hasSubmitted && errors.logo ? 'is-invalid' : ''}`}
                      accept="image/*"
                      onChange={handleLogoUpload}
                    />
                    <span className="upload-icon"></span>
                  </div>
                )}

                {logoPreview && (
                  <div className="input-file">
                    <img src={logoPreview} alt="Logo Preview" />
                    <button
                      type="button"
                      onClick={removeLogo}
                      className="close-btn"
                    >
                      ×
                    </button>
                  </div>
                )}

                <p>
                  <small className="light-text">Logo 500x500px • Max 15MB</small>
                </p>
                {hasSubmitted && errors.logo && (
                  <div className="invalid-feedback d-block">
                    {Array.isArray(errors.logo) ? errors.logo[0] : errors.logo}
                  </div>
                )}
              </div>

              <CoverImageUpload
                coverImages={coverImages}
                setCoverImages={setCoverImages}
                onRemoveImage={handleRemoveImage}
                onAddImages={handleAddImages}
                errors={errors.cover_images}
                hasSubmitted={hasSubmitted}
              />

              <div className="col-6">
                <label className="form-label">Features</label>
                <textarea
                  ref={summernoteFeaturesRef}
                  defaultValue={form.features}
                  className={hasSubmitted && errors.features ? 'is-invalid' : ''}
                ></textarea>
                {hasSubmitted && errors.features && (
                  <div className="invalid-feedback d-block">
                    {Array.isArray(errors.features) ? errors.features[0] : errors.features}
                  </div>
                )}
              </div>

              <div className="col-6">
                <label className="form-label">Benefits</label>
                <textarea
                  ref={summernoteBenefitsRef}
                  defaultValue={form.benefits}
                  className={hasSubmitted && errors.benefits ? 'is-invalid' : ''}
                ></textarea>
                {hasSubmitted && errors.benefits && (
                  <div className="invalid-feedback d-block">
                    {Array.isArray(errors.benefits) ? errors.benefits[0] : errors.benefits}
                  </div>
                )}
              </div>

              <div className="col-12">
                <label className="form-label">Description</label>
                <textarea
                  ref={summernoteDescriptionRef}
                  defaultValue={form.description}
                  className={hasSubmitted && errors.description ? 'is-invalid' : ''}
                ></textarea>
                {hasSubmitted && errors.description && (
                  <div className="invalid-feedback d-block">
                    {Array.isArray(errors.description) ? errors.description[0] : errors.description}
                  </div>
                )}
              </div>
               <div className="col-md-12">
                <div className="form-check mt-3 d-flex align-items-start">
                  <input
                    className="form-check-input me-2 mt-1"
                    type="checkbox"
                    id="termsCheck"
                    checked={acceptedTerms}
                    onChange={(e) => setAcceptedTerms(e.target.checked)}
                  />
                  <label className="form-check-label mb-0" htmlFor="termsCheck">
                    I agree to the{" "} 
                    <span 
                      className="text-primary fw-semibold text-decoration-underline" 
                      style={{ cursor: "pointer" }}
                      onClick={handleTermsClick}
                      role="button"
                      tabIndex={0}
                      onKeyDown={(e) => {
                        if (e.key === 'Enter' || e.key === ' ') {
                          handleTermsClick();
                        }
                      }}
                    >
                      Terms & Conditions
                    </span>
                    <span className="text-danger"> *</span>
                  </label>
                </div>
              </div>
              <div className="col-12 d-flex justify-content-between">
                <Link to="/my-projects"
                  className="btn btn-outline-secondary"
                  style={{ backgroundColor: "transparent" }}
                >
                  Back
                </Link>

                <button 
                  type="submit" 
                  className="btn btn-primary"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? (
                    <>
                      <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                      {isEditMode ? "Updating..." : "Submitting..."}
                    </>
                  ) : (
                    isEditMode ? "Update Project" : "Submit"
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>

        <TermsAndConditionModal
        show={showTermsModal}
        onHide={handleTermsModalHide}
        onAccept={handleTermsAccept}
      />
      </Layoutsecond>
    </ProjectFormProvider>
  );
}